<template>
  <div style="padding: 20px;overflow-y: auto;height: 100%;">
    <navcon :isshow="false" :isshowMenu="false"></navcon>
    <el-card v-loading="p_loading">
      <div class="title">
        选择店铺
        <el-button @click="openVisible" type="primary" size="small">新建店铺</el-button>
      </div>
      <div v-if="shopList.length > 0" class="sbox">
        <div @click="tochangeShop(item.shop_id, item.status)" v-for="(item, index) in shopList" :key="index" class="s_once">
          <el-image class="logo" :src="item.logo || require('../../../static/logo.png')" fit="cover"></el-image>
          <p style="font-size: 18px">{{ item.shop_cate_title }}</p>
          <p>{{ item.name }}</p>
          <template v-if="item.status == 2">
            <el-tooltip class="item" effect="dark" :content="'拒绝原因:' + item.refuse_msg" placement="bottom">
              <p :style="{ color: item.status == 0 ? '#ff9900' : item.status == 1 ? '#00dd00' : 'red' }">
                {{ item.status == 0 ? '待审核' : item.status == 1 ? '审核通过' : '审核拒绝' }}
              </p>
            </el-tooltip>
          </template>
          <template v-else>
            <p :style="{ color: item.status == 0 ? '#ff9900' : item.status == 1 ? '#00dd00' : 'red' }">
              {{ item.status == 0 ? '待审核' : item.status == 1 ? '审核通过' : '审核拒绝' }}
            </p>
          </template>
          <p style="font-size: 12px">
            店铺状态:
            <span :style="{ color: item.is_show == 0 ? 'red' : '#00dd00' }">{{ item.is_show == 0 ? '关闭' : '正常' }}</span>
          </p>
        </div>
      </div>
      <el-empty v-else description="暂无店铺"></el-empty>
    </el-card>
    <el-dialog title="店铺类型" :visible.sync="visible" :close-on-click-modal="false" width="700px" @close="visible = false">
      <div style="display: flex; align-items: center; justify-content: space-between">
        <div v-for="(item, index) in cateList" :key="index" @click="goaddStore(item.shop_cate_id)" class="s_once">
          <el-image class="logo" :src="item.logimgo || require('../../../static/logo.png')" fit="cover"></el-image>
          <p>{{ item.title }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import navcon from '../../components/navcon.vue';
import router,{resetRouter} from '@/router';
export default {
  data() {
    return {
      p_loading: false,
      visible: false,
      shopList: [],
      cateList: [],
      routerList:[]
    };
  },
  components: {
    navcon
  },
  created() {
    this.getList();
  },
  methods: {
    openVisible() {
      this.$get(this.$api.shopCateList).then((res) => {
        if (res.status == 200) {
          this.cateList = res.data.list;
          this.visible = true;
        }
      });
    },
    // 获取店铺列表
    getList() {
      this.p_loading = true;
      this.$get(this.$api.shopList).then((res) => {
        if (res.status == 200) {
          this.shopList = res.data.list;
          this.p_loading = false;
        }
      });
    },
    // 获取当前帐号的权限ids
    getRuleIds(){
      this.$get(this.$api.ruleIds).then(res => {
        if (res.status == 200) {
          localStorage.setItem('ruleIds', JSON.stringify(res.data))
          this.gowhere()
        }
      })
    },
    // 处理路由集合
    handlerRouters(list){
      list.forEach(item => {
        if(item.component&&item.path){
          this.routerList.push({path:item.path,name:item.title,keepalive:item.keepalive,'component':() => import(`@/views${item.component}`),meta:{requireAuth: true,keepalive:item.keepalive}})
        }
        if(item.child.length>0){
          this.handlerRouters(item.child)
        }
      })
    },
    // 获取权限列表
    getPermissionList(){
      this.$get(this.$api.permissionList).then(res => {
        if (res.status == 200) {
          localStorage.setItem('menuList', JSON.stringify(res.data))
          resetRouter()
          this.routerList=[]
          this.handlerRouters(res.data)
          this.routerList.forEach(item => {
            router.addRoute('index',item)
          })
          this.getRuleIds()
        }
      })
    },
    gowhere(){
      let result=JSON.parse(localStorage.getItem('menuList')).filter(item => {
        return item.rule_id==107
      })
      let path=result[0].child[0]
      if(path.type=='menu'){
        path=result[0].child[0].path
      }else{
        path=result[0].child[0].child[0].path
      }
      this.$router.push({
        path: path
      })
    },
    tochangeShop(id, status) {
      this.$get(this.$api.changeShop + id).then((res) => {
        if (res.status == 200) {
          this.$store.commit('saveShopData', res.data);
          localStorage.setItem('ishavaStore', true);
          this.getPermissionList()
        }
      });
    },
    goaddStore(type) {
      this.$router.push({
        path: '/addStore',
        query: {
          type
        }
      });
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  font-weight: 600;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sbox {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.s_once {
  width: 170px;
  padding: 20px 0 30px;
  border-radius: 20px;
  background: white;
  border: 2px solid #f5f5f5;
  box-shadow: 0 2px 8px 0 rgb(0 0 0 / 10%);
  margin-right: 20px;
  margin-bottom: 20px;
  transition: all 0.2s;
}

.s_once:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 8px 0 rgb(30 142 255 / 50%);
  cursor: pointer;
}

.logo {
  display: block;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: 0 auto;
}

.s_once p {
  font-size: 14px;
  color: #303133;
  font-weight: 600;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/chooseStore/index.vue